module.exports = __webpack_public_path__ + "static/media/company.29818989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company.png
// module id = 1370
// module chunks = 0